import { render, staticRenderFns } from "./BreakingNews.vue?vue&type=template&id=a2080f92&scoped=true"
import script from "./BreakingNews.vue?vue&type=script&lang=js"
export * from "./BreakingNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2080f92",
  null
  
)

export default component.exports